import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Spin } from 'antd';

const FaqWrapper = styled.div`
  height: 100%;
  width: 100%;
  position: relative;
`;

const spinStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  bottom: '50%',
  right: '50%',
};

const HelpCenter = (props) => {
  const { intl } = props;

  const [loading, setLoading] = useState(false);

  const init = () => {
    setLoading(true);
    const url = `https://festatic-1254389369.cos.ap-guangzhou.myqcloud.com/science/FAQ_SDK/bundle.es5.js?v=${+new Date()}`;
    const body = document.querySelector('body');
    const script = document.createElement('script');
    script.id = 'faq-script-ele';
    script.src = url;
    script.async = true;
    const ele = document.querySelector('#FAQ');
    script.onload = () => {
      setLoading(false);
      // eslint-disable-next-line
      const app = new window.FAQ.default({
        target: ele,
        props: {
          system: 11,
        },
      });
    };
    script.onerror = () => {
      setLoading(false);
      throw new Error('FAQ脚本加载错误');
    };
    const oldScript = body.querySelector('#faq-script-ele');
    if (oldScript) {
      body.replaceChild(script, oldScript);
    } else {
      body.appendChild(script);
    }
  };

  useEffect(() => {
    init();
  }, []);

  return (
    <div>
      <FaqWrapper id="FAQ">{loading ? <Spin size="large" style={spinStyle} /> : null}</FaqWrapper>
    </div>
  );
};

export default HelpCenter;
